import { Platform } from "@angular/cdk/platform";
import { Component, ElementRef, inject, input, Renderer2,  effect } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
// import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
// import { SanitizeHtmlPipe } from "app/shared/pipes/sanitize-html.pipe";
import { FromServerService } from "app/shared/services/from-server/from-server.service";

@Component({
  standalone: true,
  selector: 'html-content',
  template: ``
})
export class HTMLContentComponent/* implements AfterViewInit */ {    
  content = input<string>();
  image = input<string>(''); 
  platform = inject(Platform);
  formServerService = inject(FromServerService);
  renderer = inject(Renderer2);
  elementRef = inject(ElementRef);
  sanitizer = inject(DomSanitizer);

  constructor() {
    effect(() => {
      /* Creating a variable is not necessary, but this.content() has to be triggered in some way to create a reactive context */
      const newContent = this.content();
      if(!this.platform.isBrowser || !this.formServerService.isFromServer) {
        const sanitized = this.sanitizer.bypassSecurityTrustHtml(newContent);
        this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', sanitized['changingThisBreaksApplicationSecurity']);
      }
    })
  }

  // ngAfterViewInit(): void {
  //   if(!this.platform.isBrowser || !this.formServerService.isFromServer) {
  //     const sanitized = this.sanitizer.bypassSecurityTrustHtml(this.content());
  //     this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', sanitized['changingThisBreaksApplicationSecurity']);
  //   }
  // }
}
